if (!customElements.get('mirthloom-lizard')) customElements.define('mirthloom-lizard', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.events = new AbortController();
    const opts = { signal: this.events.signal };
    const slides = this.querySelector('.lz-slides');
    const thumbs = [...this.querySelectorAll('[data-photo]')];
    const go = i => slides.scrollTo({ left: i * slides.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    thumbs.forEach((b, i) => b.addEventListener('click', () => go(i), opts));
    slides.addEventListener('scroll', () => thumbs.forEach((b, i) => b.setAttribute('aria-pressed', String(i === Math.round(slides.scrollLeft / slides.clientWidth)))), { ...opts, passive: true });
    slides.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      go(Math.max(0, Math.min(thumbs.length - 1, Math.round(slides.scrollLeft / slides.clientWidth) + (e.key === 'ArrowRight' ? 1 : -1))));
    }, opts);
    const form = this.querySelector('form');
    const syncSelectedPrice = () => {
      const selected = form.querySelector('[name="quantity"]:checked');
      const price = selected?.closest('.lz-pack')?.querySelector('.lz-pack-price');
      if (!price) return;
      this.querySelector('[data-selected-price]').textContent = price.querySelector('strong').textContent;
      const compare = this.querySelector('[data-selected-compare]');
      const saving = this.querySelector('[data-selected-saving]');
      if (compare) { compare.textContent = price.dataset.compare; compare.hidden = Number(price.dataset.saving) <= 0; }
      if (saving) { saving.textContent = (this.dataset.saveLabel || 'SAVE __PERCENT__%').replace('__PERCENT__', price.dataset.saving); saving.hidden = Number(price.dataset.saving) <= 0; }
    };
    form.addEventListener('change', syncSelectedPrice, opts);
    syncSelectedPrice();
    const button = form.querySelector('.lz-buy');
    const error = this.querySelector('.lz-error');
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (this.busy) return;
      this.busy = true; button.disabled = true; button.setAttribute('aria-busy', 'true'); error.hidden = true;
      try {
        if (!this.added) {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: Number(form.querySelector('[name=quantity]:checked').value) }] }) });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Unable to add this item. Please try again.');
          this.added = true;
        }
        const drawer = document.querySelector('cart-drawer');
        if (!drawer?.renderContents) throw new Error('Items added. Please refresh to view your saved cart.');
        const url = new URL(window.Shopify?.routes?.root || '/', location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
        const response = await fetch(url, { cache: 'no-store' });
        if (!response.ok) throw new Error('Items added. Select VIEW CART to retry opening your cart.');
        const sections = await response.json();
        if (!sections['cart-drawer']) {
          url.searchParams.delete('sections'); url.searchParams.set('section_id', 'cart-drawer');
          const fallback = await fetch(url, { cache: 'no-store' });
          if (fallback.ok) sections['cart-drawer'] = await fallback.text();
        }
        if (!new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html').querySelector('#CartDrawer')) throw new Error('Items added. Select VIEW CART to retry opening your cart.');
        if (!sections['cart-icon-bubble']) sections['cart-icon-bubble'] = '<div class="shopify-section">' + (document.getElementById('cart-icon-bubble')?.innerHTML || '') + '</div>';
        drawer.setActiveElement(button); drawer.renderContents({ sections }); this.added = false;
      } catch (err) { error.textContent = err.message; error.hidden = false; }
      finally { this.busy = false; button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = this.added ? this.dataset.cartLabel : this.dataset.buyLabel; }
    }, opts);
  }
  disconnectedCallback() { this.events?.abort(); this.ready = false; }
});
